import { getAlldata } from "../../controllers/APIController";

const func = async () => {
  const data = await getAlldata("sectors");
  const list = data?.data;
  const valuesList = list?.map((item) => {
    return { key: item?.toLowerCase(), name: item };
  });
  return valuesList;
};
export const OnboardingOrgDataSchema = {
  Name: {
    id: 1,
    name: "Text Input",
    type: "text",
    title: "Name",
    required: true,
    char_limit: "",
    placeholder: "Enter your organization name",
  },
  URL: {
    id: 2,
    name: "Text Input",
    type: "url",
    title: "URL",
    required: true,
    placeholder: " ",
    isDisable: true,
    startContent: (
      <div className="pointer-events-none flex items-center">
        <span className="text-default-400 text-small">
          {`${process.env.REACT_APP_IP_ADDRESS}/`}
        </span>
      </div>
    ),
  },
  "Financial Year": {
    id: 1,
    name: "Text Input",
    type: "text",
    title: "Financial Year",
    required: true,
    char_limit: "",
    placeholder: "Enter the financial year",
  },
  "Choose Your Region": {
    id: 3,
    name: "Drop Down",
    type: "dropdown",
    title: "Choose Your Region",
    placeholder: "Enter your Region",
    values: [
      { key: "us-east", name: "us-east" },
      { key: "us-west", name: "us-west" },
      { key: "us-north", name: "us-north" },
      { key: "us-south", name: "us-south" },
    ],
    required: true,
    ismultiselect: false,
  },
  "Choose Industry Sector": {
    id: 4,
    name: "Drop Down",
    type: "dropdown",
    title: "Choose Industry Sector",
    placeholder: "Enter Industry Sector",
    values: [],
    required: true,
    ismultiselect: false,
  },
  "Financial Name": {
    id: 1,
    name: "Text Input",
    type: "text",
    title: "Financial Name",
    required: true,
    char_limit: "",
    placeholder: "Name of Your Financial Year",
  },
  "Start Date": {
    id: 5,
    name: "Date",
    type: "date",
    title: "Start Date",
    required: true,
  },
  "End Date": {
    id: 6,
    name: "Date",
    type: "date",
    title: "End Date",
    required: true,
  },
  // BRSR Fields
  "Corporate Identity Number": {
    id: 7,
    name: "Text Input",
    type: "text",
    title: "Corporate Identity Number",
    required: false,
    char_limit: "",
    placeholder: "Enter CIN of the Listed Entity",
  },
  "Listed Entity Name": {
    id: 8,
    name: "Text Input",
    type: "text",
    title: "Listed Entity Name",
    required: false,
    char_limit: "",
    placeholder: "Enter name of the Listed Entity",
  },
  "Year of Incorporation": {
    id: 9,
    name: "Text Input",
    type: "text",
    title: "Year of Incorporation",
    required: false,
    char_limit: "",
    placeholder: "Enter year of incorporation",
  },
  "Registered Office Address": {
    id: 10,
    name: "Text Input",
    type: "text",
    title: "Registered Office Address",
    required: false,
    char_limit: "",
    placeholder: "Enter registered office address",
  },
  "Corporate Address": {
    id: 11,
    name: "Text Input",
    type: "text",
    title: "Corporate Address",
    required: false,
    char_limit: "",
    placeholder: "Enter corporate address",
  },
  "Email": {
    id: 12,
    name: "Text Input",
    type: "email",
    title: "Email",
    required: false,
    char_limit: "",
    placeholder: "Enter email address",
  },
  "Telephone": {
    id: 13,
    name: "Text Input",
    type: "tel",
    title: "Telephone",
    required: false,
    char_limit: "",
    placeholder: "Enter telephone number",
  },
  "Website": {
    id: 14,
    name: "Text Input",
    type: "url",
    title: "Website",
    required: false,
    char_limit: "",
    placeholder: "Enter website URL",
  },
  "Stock Exchange": {
    id: 15,
    name: "Text Input",
    type: "text",
    title: "Stock Exchange",
    required: false,
    char_limit: "",
    placeholder: "Enter name of Stock Exchange(s) where shares are listed",
  },
  "Paid-up Capital": {
    id: 16,
    name: "Text Input",
    type: "text",
    title: "Paid-up Capital",
    required: false,
    char_limit: "",
    placeholder: "Enter paid-up capital",
  },
  "BRSR Contact Person": {
    id: 17,
    name: "Text Input",
    type: "text",
    title: "BRSR Contact Person",
    required: false,
    char_limit: "",
    placeholder: "Enter name of BRSR contact person",
  },
  "BRSR Contact Phone": {
    id: 18,
    name: "Text Input",
    type: "tel",
    title: "BRSR Contact Phone",
    required: false,
    char_limit: "",
    placeholder: "Enter BRSR contact phone number",
  },
  "BRSR Contact Email": {
    id: 19,
    name: "Text Input",
    type: "email",
    title: "BRSR Contact Email",
    required: false,
    char_limit: "",
    placeholder: "Enter BRSR contact email address",
  },
  "Reporting Boundary": {
    id: 20,
    name: "Drop Down",
    type: "dropdown",
    title: "Reporting Boundary",
    placeholder: "Select reporting boundary",
    values: [
      { key: "standalone", name: "Standalone basis (only for the entity)" },
      { key: "consolidated", name: "Consolidated basis (entity and all subsidiaries)" },
    ],
    required: false,
    ismultiselect: false,
  },
  "Assurance Provider": {
    id: 21,
    name: "Text Input",
    type: "text",
    title: "Assurance Provider",
    required: false,
    char_limit: "",
    placeholder: "Enter name of assurance provider",
  },
  "Assurance Type": {
    id: 22,
    name: "Drop Down",
    type: "dropdown",
    title: "Assurance Type",
    placeholder: "Select type of assurance obtained",
    values: [
      { key: "limited", name: "Limited Assurance" },
      { key: "reasonable", name: "Reasonable Assurance" },
      { key: "none", name: "No Assurance" },
    ],
    required: false,
    ismultiselect: false,
  },
};

export const intialOrgData = {
  Name: "",
  URL: "",
  "Financial Year": "",
  "Choose Your Region": "",
  "Select Framework": [],
  tags: [],
  "Choose Industry Sector": "",
  "Financial Name": "",
  "Start Date": "",
  "End Date": "",
  // BRSR Fields
  "Corporate Identity Number": "",
  "Listed Entity Name": "",
  "Year of Incorporation": "",
  "Registered Office Address": "",
  "Corporate Address": "",
  "Email": "",
  "Telephone": "",
  "Website": "",
  "Stock Exchange": "",
  "Paid-up Capital": "",
  "BRSR Contact Person": "",
  "BRSR Contact Phone": "",
  "BRSR Contact Email": "",
  "Reporting Boundary": "",
  "Assurance Provider": "",
  "Assurance Type": "",
};
